import React from "react";
import { toast } from "react-toastify";
import _ from "lodash";

export const validateHotelSearch = (form) => {
  const msgs = [];
  if (
    !form.destinationObj.destination_code.length &&
    _.isEmpty(form.destinationObj.destination_meta)
  ) {
    msgs.push("Please select a destination");
  }

  if (!form.datesArray[0]) {
    msgs.push("Please select a check in date.");
  }

  if (!form.datesArray[1]) {
    msgs.push("Please select a check out date.");
  }

  if (form.children > 0 && form.children_ages.length !== form.children) {
    msgs.push("Please set ages for all children.");
  }
  if (msgs.length) {
    toast.warning(
      <ul>
        {msgs.map((msg, idx) => (
          <li key={idx}>{msg}</li>
        ))}
      </ul>,
      { duration: 5000 }
    );
    return false;
  }
  return true;
};

/**
 * Validates search data after decoding
 * @param {*} form
 * @returns
 */
export const validateNewHotelSearch = (form) => {
  const msgs = [];
  if (!form.destinationObj.destination_code.length) {
    msgs.push(false);
  }
  if (!form.datesArray[0] || !form.datesArray[0]) {
    msgs.push(false);
  }
  if (msgs.length) {
    return false;
  }
  return true;
};
